import React from 'react'
import ProjectCard from '../components/ProjectCard'
import proj1 from "../assets/Home_Screen_Dark_Mode_Full_Size_Card.jpg"
import proj2 from "../assets/home_screen.jpg"
import proj3 from "../assets/home_proj_firebase.jpg"
import proj4 from "../assets/home_wordlegame.jpg"
import { Link} from 'react-router-dom'

const Projects = () => {
  
  return (
    <div className='grid gap-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 p-4 md:p-2 xl:p-5'>
      <div className="relative bg-gradient-to-r from-green-50 to-green-400 border rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700 transform transition duration-500 hover:scale-105 ">
          {/* ------------------- */}
          <div className="p-2 flex justify-center">
              <Link>
                <ProjectCard name="First Project" image={proj1}/>
              </Link>
          </div>

          <div className="px-4 pb-3">
              <div>
                  <h5
                      className="text-sm font-semibold tracking-tight hover:text-violet-800 dark:hover:text-violet-300 text-gray-900  mb-7">
                      This Website enables users to add products seen in online stores for future reference. It allows users to save product details, including the website address link for future purchases with mongoDB.
                  </h5>
              </div>
              <Link to={"https://github.com/MosheBens/Product-List-Stack-MERN"} className="text-white bg-blue-700 hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" target="_blank">Link To GitHub Repository</Link>
          </div>
        </div>
      {/* -------------------------------- */}
      <div className="relative bg-gradient-to-r from-stone-50 to-stone-300 border rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700 transform transition duration-500 hover:scale-105">
        <div className="p-2 flex justify-center">
            <Link>
              <ProjectCard name="Second Project" image={proj2}/>
            </Link>
        </div>

        <div className="px-4 pb-3">
            <div>    
                <h5
                    className="text-sm font-semibold tracking-tight hover:text-violet-800 dark:hover:text-violet-300 text-gray-900  mb-7">
                    A website that gives the user the opportunity to register and connect to his personal user, thus add a new recipe or save a recipe of another user with mongoDB. The recipe that the user adds will be uploaded to the home page and will be open to everyone.
                </h5> 
            </div>
            <Link to={"https://github.com/MosheBens/MERN-Recipe-App"} className="text-white bg-blue-700 hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" target="_blank">Link To GitHub Repository</Link>
        </div>

      </div>
      {/* ------------------- */}
      <div className="relative bg-gradient-to-r from-cyan-50 to-cyan-400 border rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700 transform transition duration-500 hover:scale-105">
        <div className="p-2 flex justify-center">
            <Link>
              <ProjectCard name="Second Project" image={proj3}/>
            </Link>
        </div>

        <div className="px-4 pb-3">
            <div>    
                <h5
                    className="text-sm font-semibold tracking-tight hover:text-violet-800 dark:hover:text-violet-300 text-gray-900  mb-7">
This site allows users to manage their monthly expenses and income with Firebase Data Base. Users can access the application on both computers and phones. It features Google Authentication and responsive web design.                </h5> 
            </div>
            <Link to={"https://github.com/MosheBens/expense-app"} className="text-white bg-blue-700 hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" target="_blank">Link To GitHub Repository</Link>
        </div>

      </div>
      {/* ------------------- */}
      <div className="relative bg-gradient-to-r from-yellow-50 to-yellow-500 border rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700 transform transition duration-500 hover:scale-105">
        <div className="p-2 flex justify-center">
            <Link>
              <ProjectCard name="Second Project" image={proj4}/>
            </Link>
        </div>

        <div className="px-4 pb-3">
            <div>    
                <h5
                    className="text-sm font-semibold tracking-tight hover:text-violet-800 dark:hover:text-violet-300 text-gray-900  mb-7">
Cool Wordle-Game, user friendly and responsive design.</h5> 
            </div>
            <Link to={"https://github.com/MosheBens/wordlegame"} className="text-white bg-blue-700 hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" target="_blank">Link To GitHub Repository</Link>
        </div>

      </div>
      {/* ------------------ */}
    </div>
  )
} 

export default Projects